import { LeftMenuFacade } from "./left-menu.facade";

export { LeftMenuFacade };

export default [LeftMenuFacade];
